import React from 'react';
import { Button } from '@/components/ui/button';
import { Bell } from 'lucide-react';
import { 
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { CommonLabel } from '@/components/ui/common-label';

export function NotificationMenu({ theme }) {
  const notifications = [

  ];

  const unreadCount = notifications.filter(n => n.unread).length;

  const iconButtonClasses = 
    `rounded-[13px] shadow-[0px_4.9px_19.6px_0px_#6A73811F] border border-border relative focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0`;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="none"
          size="icon"
          className={iconButtonClasses}
        >
          <Bell className="w-5 h-5" />
          {unreadCount > 0 && (
            <span className="absolute top-1.5 right-1.5 w-2.5 h-2.5 bg-[hsl(var(--notification-dot))] rounded-full border-2 border-card"></span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-80" align="end" forceMount theme={theme}>
        <DropdownMenuLabel className="flex items-center justify-between">
          <CommonLabel size="lg" weight="bold" className="text-foreground">
            Notifications
          </CommonLabel>
          {unreadCount > 0 && (
            <CommonLabel size="sm" weight="normal" className="text-muted-foreground">
              {unreadCount} unread
            </CommonLabel>
          )}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {notifications.map((notification) => (
          <DropdownMenuItem 
            key={notification.id}
            className={`flex flex-col items-start py-3 ${notification.unread ? 'bg-accent' : ''}`}
          >
            <div className="flex w-full justify-between">
              <CommonLabel size="sm" weight="semibold" className="text-foreground">
                {notification.title}
              </CommonLabel>

              <CommonLabel size="xs" className="text-muted-foreground whitespace-nowrap">
                {notification.time}
              </CommonLabel>
            </div>
            <CommonLabel size="xs" className="text-muted-foreground mt-1">
              {notification.description}
            </CommonLabel>
          </DropdownMenuItem>
        ))}
        
        {notifications.length === 0 && (
          <DropdownMenuItem className="flex flex-col items-center justify-center py-6">
            <div className="text-center mb-2">
              <Bell className="w-8 h-8 mx-auto text-muted-foreground" />
            </div>
            <CommonLabel size="sm" weight="medium" className="text-muted-foreground">
              No new notifications
            </CommonLabel>
          </DropdownMenuItem>
        )}
        
        {notifications.length > 0 && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem className="flex justify-center">
              <CommonLabel size="sm" weight="medium" className="text-primary">
                View all notifications
              </CommonLabel>
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
